import React from 'react';
import GarbageSortingGame from './components/GarbageSortingGame';
import './App.css';

function App() {
  return (
    <div className="App">
      <GarbageSortingGame />
    </div>
  );
}

export default App;